import { NgModule } from '@angular/core';
import { AppInsightsConfig } from '@epicuro-next/models/platform/monitoring';
import {
  EnvironmentSettings,
  ENVIRONMENT_SETTINGS,
} from '@epicuro-next/platform/environment';
import {
  AppInsightsModule,
  APPINSIGHTS_CONFIG,
  MonitoringModule,
} from '@epicuro-next/platform/monitoring';

import { environment } from '../../environments/environment.prod';

/**
 * Builds the configuration object required by App Insights monitoring.
 * @param environmentSettings
 */
function getAppInsightsSettings(
  environmentSettings: EnvironmentSettings,
): AppInsightsConfig {
  return {
    config: {
      instrumentationKey: environmentSettings.appInsightsApiKey,
      disableAjaxTracking: !environment.production,
      enableDebug: !environment.production,
    },
  };
}

/**
 * Module to configure monitoring for the Epicuro app
 */
@NgModule({
  declarations: [],
  imports: [MonitoringModule, AppInsightsModule],
  providers: [
    {
      provide: APPINSIGHTS_CONFIG,
      useFactory: getAppInsightsSettings,
      deps: [ENVIRONMENT_SETTINGS],
    },
  ],
})
export class EpcMonitoringModule {}
